/*
 * TCD additive adapter for Canopy's variant-picker, only on the Lengths template.
 * Canopy continues to handle prices, media, form IDs, cart and variant events.
 * A colour with no currently selected length gets a real offered length, never
 * a synthetic/out-of-stock combination. Context comes from Shopify's response.
 */
if (!customElements.get('tcd-length-picker-controller')) {
  customElements.define('tcd-length-picker-controller', class extends HTMLElement {
    connectedCallback() {
      customElements.whenDefined('variant-picker').then(() => {
        if (!this.isConnected) return;
        const picker = this.closest('variant-picker[data-tcd-length-picker]');
        if (!picker) return;
        this.preservePreview(picker);
        // Canopy reattaches its listeners 10ms after replacing option content.
        this.selectionTimer = setTimeout(() => this.ensureOfferedSelection(picker), 40);
      });
    }

    disconnectedCallback() {
      clearTimeout(this.selectionTimer);
    }

    preservePreview(picker) {
      if (picker.tcdLengthPreviewReady) return;
      picker.tcdLengthPreviewReady = true;
      const params = new URLSearchParams(window.location.search);
      const retained = ['view', 'preview_theme_id', '_fd', 'pb']
        .filter((key) => params.has(key)).map((key) => [key, params.get(key)]);
      if (!retained.length) return;
      const construct = picker.constructVariantUrl.bind(picker);
      picker.constructVariantUrl = (...args) => {
        const url = construct(...args);
        retained.forEach(([key, value]) => url.searchParams.set(key, value));
        return url;
      };
      const updateUrl = picker.updateUrl.bind(picker);
      picker.updateUrl = () => {
        updateUrl();
        if (picker.dataset.updateUrl === 'false') return;
        const url = new URL(window.location.href);
        retained.forEach(([key, value]) => url.searchParams.set(key, value));
        window.history.replaceState({}, '', url);
      };
    }

    ensureOfferedSelection(picker) {
      if (!this.isConnected || !picker.isConnected) return;
      const lengths = picker.querySelector('.option-selector--length');
      if (!lengths || lengths.querySelector('input:checked')) return;
      const inputs = [...lengths.querySelectorAll('input.js-option[data-variant-id]')];
      const next = inputs.find((input) => !input.classList.contains('is-unavailable')) || inputs[0];
      if (next) next.click();
    }
  });
}
